import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { PictureLever } from "project-config/constants";
import PictureNormal from "@/assets/images/picture-normal.png";
import PictureVip from "@/assets/images/picture-vip.png";
import { IVipRechargeInfo } from "../types";

const t = getTranslateNsT("topup");

export const VipRechargeInfo: IVipRechargeInfo[] = [
  {
    type: 1,
    vipMonth: 1,
    price: 19.9,
    originalPrice: 25,
  },
  {
    type: 3,
    vipMonth: 3,
    price: 58,
    originalPrice: 75,
    perMonth: 19.3,
    badgeText: "特惠",
  },
  {
    type: 6,
    vipMonth: 6,
    price: 110,
    originalPrice: 150,
    perMonth: 18.3,
  },
  {
    type: 2,
    vipMonth: 12,
    price: 199,
    originalPrice: 300,
    perMonth: 16.5,
  },
];

// 常规会员订阅规则
export const NormalVipRechargeRules = [
  t("picture_recharge_rules_0"),
  t("picture_recharge_rules_1"),
  t("picture_recharge_rules_2"),
  t("picture_recharge_rules_3"),
  t("picture_recharge_rules_4"),
];

export const PictureMemberType = new Map([
  [
    PictureLever.Normal,
    {
      bgImg: PictureNormal,
      text: t("picture_normal_card_text"),
    },
  ],
  [
    PictureLever.Member,
    {
      bgImg: PictureVip,
      text: t("picture_vip_card_text"),
    },
  ],
]);

export const pictureMemberPrivilege = [
  {
    title: t("picture_privilege_title_1"),
    subTitle: t("picture_privilege_subtitle_1"),
  },
  {
    title: t("picture_privilege_title_2"),
    subTitle: t("picture_privilege_subtitle_2"),
  },
  {
    title: t("picture_privilege_title_3"),
    subTitle: t("picture_privilege_subtitle_3"),
  },

  {
    title: t("picture_privilege_title_4"),
    subTitle: t("picture_privilege_subtitle_4"),
  },
];
